export type StopStatus = 'Delivered' | 'In Progress' | 'Pending';

export interface RouteStat { id: string; label: string; value: string }
export interface RouteHeader { routeId: string; date: string }

export interface RouteStop {
  id: string;
  index: number;
  name: string;
  address: string;
  contact: string;
  orderId: string;
  status: StopStatus;
}

export function backendStopStatusToUi(s: string): StopStatus {
  if (s === 'delivered') return 'Delivered';
  if (s === 'in_transit') return 'In Progress';
  return 'Pending';
}
